(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('ContractFormController', ContractFormController);

  /* ngInject */
  function ContractFormController($state, $stateParams, Flash, branchService, contractService, contractStatuses, customFieldDefinitionService, departmentService, formErrorsService, vmsProductService, sessionService, vendorService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.branches = [];
    vm.contract = {};
    vm.contractStatuses = contractStatuses;
    vm.customFieldDefinitions = [];
    vm.departments = [];
    vm.form = {};
    vm.id = $stateParams.id;
    vm.products = [];
    vm.refreshContractRenewal = refreshContractRenewal;
    vm.saveContract = saveContract;
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      if (vm.id) {
        getContract();
      } else {
        vm.contract.vendor_id = vm.vendorId;
      }

      getBranches();
      getCustomFieldDefinitions();
      getDepartments();
      getProducts();
      getVendor();
    }

    function getBranches() {
      branchService(sessionService.getAuthToken()).query({}, response => vm.branches = response);
    }

    function getContract() {
      contractService(sessionService.getAuthToken()).get({ id: $stateParams.id }, response => {
        vm.contract = response;
        vm.contract.product_ids = vm.contract.products.map(product => product.id);

        for (var [key, value] of Object.entries(vm.contract.custom_fields)) {
          vm.contract[key] = value;
        }
      });
    }

    function getCustomFieldDefinitions() {
      customFieldDefinitionService(sessionService.getAuthToken()).query({ class_name: 'Contract' }, response => {
        vm.customFieldDefinitions = response;
      });
    }

    function getDepartments() {
      departmentService(sessionService.getAuthToken()).query({}, response => vm.departments = response);
    }

    function getProducts() {
      vmsProductService(sessionService.getAuthToken()).query({ vendorId: vm.vendorId }, response => vm.products = response);
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }

    function saveContract() {
      if (vm.id) {
        contractService(sessionService.getAuthToken()).update({ id: vm.id }, vm.contract,
          _ => {
            $state.go('application.vms.contract-detail', { vendorId: vm.vendorId, id: vm.id });
            Flash.create('success', 'Contract successfully updated.');
          }, error => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
            vm.setFormErrors(vm.form, error);
          }
        );
      } else {
        contractService(sessionService.getAuthToken()).create({}, vm.contract,
          response => {
            $state.go('application.vms.contract-detail', { vendorId: vm.vendorId, id: response.contract.id });
            Flash.create('success', 'Contract successfully created.');
          }, error => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
            vm.setFormErrors(vm.form, error);
          }
        );
      }
    }

    function refreshContractRenewal() {
      if (vm.contract.renewal_type == 'None' || !vm.contract.has_expiration) {
        vm.contract.renewal_type = 'None';
        vm.contract.renewal_term_months = null;
        vm.contract.renewal_start_date = null;
        vm.contract.term_notice_days = null;
        vm.contract.renewal_deadline = null;
      } else if (vm.contract.renewal_type == 'Automatic') {
        if (vm.contract.end_date) {
          vm.contract.renewal_start_date = vm.contract.end_date;

          /* eslint-disable no-undef */
          var endDate = moment(vm.contract.end_date);
          /* eslint-enable no-undef */

          var renewalDeadline = endDate.subtract(vm.contract.term_notice_days, 'days');
          vm.contract.renewal_deadline = renewalDeadline.format('YYYY-MM-DD');
        }
      }
    }
  }
})();
